import { inject, Injectable } from '@angular/core';
import { GuildEntity, GuildShortInfoGQL, GuildMemberShortInfoGQL, GuildMemberEntity } from '@generated/gql';
import { BaseSubgraphService } from '@services/graph/base-subgraph.service';
import { map, Observable, retry } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GuildSubgraphService extends BaseSubgraphService {
  private readonly guildShortInfoGQL: GuildShortInfoGQL = inject(GuildShortInfoGQL);
  private readonly guildMemberShortInfoGQL: GuildMemberShortInfoGQL = inject(GuildMemberShortInfoGQL);

  constructor() {
    super();
  }

  guildShortInfo$(id: string): Observable<GuildEntity> {
    return this.guildShortInfoGQL.fetch({ id }).pipe(
      map(x => x.data.guildEntity as GuildEntity),
      retry(this.retry()),
    );
  }

  guildMemberShortInfo$(id: string): Observable<GuildMemberEntity> {
    return this.guildMemberShortInfoGQL.fetch({ id }).pipe(
      map(x => x.data.guildMemberEntity as GuildMemberEntity),
      retry(this.retry()),
    );
  }
}
